// email.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiUrls } from 'src/app/utils/apiUrls';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  
  constructor(private http: HttpClient) { }

  checkEmailExists(email: string): Observable<string> {
    // Replace with your backend API endpoint for checking email existence
    const url =apiUrls.emailCheck+`?email=${email}`;
    return this.http.post<string>(url,{});
  }

  checkEmailStatusExists(email: string, type: any): Observable<string> {
    const url =apiUrls.emailStatusCheck+`?email=${email}&userType=${type}`;
    return this.http.get<string>(url,{});
  }
}
